import { Params } from '@angular/router';
import { Injectable } from '@angular/core';

import { HttpService } from '@/app/core/services/http';

import { User, CreateUser, UpdateUser, UsersFiltersQueryParams } from './users.types';

@Injectable({
  providedIn: 'root',
})
export class UsersService {
  constructor(private http: HttpService) {}

  getUsersWithPagination(params?: Params) {
    return this.http.getAllWithPagination<User>('users', { params });
  }

  getUsersFilters(params?: UsersFiltersQueryParams) {
    return this.http.getFilters('users/filters', params);
  }

  createUser(body: CreateUser) {
    return this.http.post<User>('users', body);
  }

  updateUser(id: number, body: UpdateUser) {
    return this.http.put<User>(`users/${id}`, body);
  }

  deleteUser(id: number) {
    return this.http.delete(`users/${id}`);
  }
}
